import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useApplicationFetchers } from '../../../fetchers/use-application-fetchers';

const skillLocalesKey = () => ['skill-locales'] as const;

export const useSkillLocales = (): UseQueryResult<readonly string[], Error> => {
    const { fetchSkillLocales } = useApplicationFetchers();

    return useQuery({
        queryFn: async () => {
            const result = await fetchSkillLocales();

            if (result.isErr === true) {
                throw result.error;
            }

            return result.value;
        },
        queryKey: skillLocalesKey(),
        staleTime: 1000 * 60 * 60,
        throwOnError: false,
    });
};
